import { render, staticRenderFns } from "./developers.vue?vue&type=template&id=971f4448&scoped=true&"
import script from "./developers.vue?vue&type=script&lang=js&"
export * from "./developers.vue?vue&type=script&lang=js&"
import style0 from "./developers.vue?vue&type=style&index=0&id=971f4448&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971f4448",
  null
  
)

export default component.exports